import { useQuery } from '@apollo/client';

import { USER_BY_ID, USER_LIST, USER_ME, USER_MY_PERMISSIONS, USER_PERMISSIONS } from '../apollo/typeDefs/user';

export const useUserMeQuery = (): any => (
  useQuery(USER_ME)
);

export const useQueryUserMyPermissions = (): any => (
  useQuery(USER_MY_PERMISSIONS)
);

export const useUserByIdQuery = (options?: any): any => (
  useQuery(USER_BY_ID, options)
);

export const useUserListQuery = (options?: any): any => (
  useQuery(USER_LIST, options)
);

export const useQueryUserPermissions = (options?: any): any => (
  useQuery(USER_PERMISSIONS, options)
);

